import React from "react";

const NotFoundPage = () => {
  return <div>page Not found 404</div>;
};

export default NotFoundPage;
